import React from 'react'
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  useTheme,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { LCDOptionsContentProps } from '../types'
import getLocaleCurrencyForAmount from '../../../../utils/getLocaleCurrencyForAmount'
import AdjacentLabels from '../../../Labels/AdjacentLabels'
import { LcdAmountSelection } from '../../utils/paymentModalSteps'

const LabelText = ({ children }: { children: React.ReactNode }) => (
  <Typography variant="subtitle1">{children}</Typography>
)

const LCDOptionsContent: React.FC<LCDOptionsContentProps> = ({
  amountOption,
  setAmountOption,
  totalAmountDue,
  totalAmountOwed,
  defaultCurrencyCode,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <FormControl>
      <RadioGroup
        aria-label="amount selection"
        name="amount selection"
        value={amountOption}
        defaultValue={amountOption}
        onChange={(e) => setAmountOption(e.target.value as LcdAmountSelection)}
      >
        <FormControlLabel
          key={'payTotalAmountDue'}
          value={'payTotalAmountDue'}
          control={
            <Radio
              sx={{
                color: theme.palette.textOrIcon.checkbox,
              }}
            />
          }
          label={
            <AdjacentLabels
              leftLabel={t(
                'LCDOptionsContent.Option.PayTotalAmountDue',
                'Pay the total amount due'
              )}
              rightLabel={`${getLocaleCurrencyForAmount(
                totalAmountDue.amount,
                totalAmountDue.currencyCode ?? defaultCurrencyCode
              )}`}
            />
          }
        />
        <FormControlLabel
          key={'payTotalAmountOwed'}
          value={'payTotalAmountOwed'}
          control={
            <Radio
              sx={{
                color: theme.palette.textOrIcon.checkbox,
              }}
            />
          }
          label={
            <AdjacentLabels
              leftLabel={t(
                'LCDOptionsContent.Option.PayTotalAmountOwed',
                'Pay the total balance'
              )}
              rightLabel={`${getLocaleCurrencyForAmount(
                totalAmountOwed?.amount ?? '0.00',
                totalAmountOwed?.currencyCode ?? defaultCurrencyCode
              )}`}
            />
          }
        />
        <FormControlLabel
          key={'enterDifferentAmount'}
          value={'enterDifferentAmount'}
          control={
            <Radio
              sx={{
                color: theme.palette.textOrIcon.checkbox,
              }}
            />
          }
          label={
            <LabelText>
              {t(
                'LCDOptionsContent.Option.EnterDifferentAmount',
                'Enter a different amount'
              )}
            </LabelText>
          }
        />
      </RadioGroup>
    </FormControl>
  )
}

export default LCDOptionsContent
